import React from "react";

const EmptyState = ({ title, message, action }) => (
  <div className="text-center py-20" data-testid="empty-state">
    {title && <h2 className="font-anton text-4xl uppercase">{title}</h2>}
    {message && <p className="mt-4 text-zinc-400">{message}</p>}
    {action && <div className="mt-8">{action}</div>}
  </div>
);

export default EmptyState;
